import React from "react";
import styled from "styled-components";
import logo from "../imgs/logo.svg";

const HeaderStyles = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  background: ${({ theme }) => theme.colors.primary};
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    width: 110px;
  }
  z-index: 3;
`;

const Header = () => {
  return (
    <HeaderStyles>
      <img src={logo} alt="geordify" />
    </HeaderStyles>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js